import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Avatar } from "@mui/material";
import ProgressBar from "../../../../UI/ProgressBar";
import { useGetDepartmentUserStatisticsQuery } from "../../../../../redux-toolkit/features/reports/ReportsApiSlice";
import { Error404 } from "../../../../UI/404/Error404";
import { SortIcon } from "../../../Manage Organization/Employee/EmployeeTable";

export const UserStatisticTable = ({
  check,
  searchQuery = "",
  getTableData,
  startDate,
  endDate,
}) => {
  const [sortBy, setSortBy] = useState("");
  const [sortType, setSortType] = useState("asc");

  const { data, isError, isLoading } = useGetDepartmentUserStatisticsQuery(
    {
      sortBy: sortBy,
      type: sortType,
      query: searchQuery,
      startDate,
      endDate,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  React.useEffect(() => {
    if (!data) return;
    getTableData && getTableData(data);
  }, [data]);

  const handleSorting = (sortKey) => {
    setSortBy(sortKey);
    setSortType(!sortType || sortType === "desc" ? "asc" : "desc");
  };

  React.useEffect(() => {}, [check]);
  if (isLoading) {
    return <ProgressBar />;
  }

  if (isError) {
    return <Error404 />;
  }
  return (
    <div>
      <TableContainer
        sx={{
          height: '100%',
          maxHeight: 'calc( 100vh - 220px)',
          padding: '0 1px',
          width: '100%',
          minWidth: '1267px',
        }}>
        <Table
          stickyHeader
          aria-label="sticky table">
          <TableHead>
            <TableRow
              sx={{ borderRadius: '20px 20px 0px 0px' }}
              className="tableUi__head">
              {check.depName && (
                <TableCell
                  sx={{ borderRadius: '20px 0px 0px 0px' }}
                  align="center"
                  onClick={() => handleSorting('name')}>
                  <div className="tableUi__head_sortable">
                    Department Name <SortIcon sortOrder={sortType} />
                  </div>
                </TableCell>
              )}
              {check.hod && (
                <TableCell align="center">Department HOD</TableCell>
              )}
              {check.totalUsers && (
                <TableCell align="center">Total user</TableCell>
              )}
              {check.activeUsers && (
                <TableCell align="center">Total Active user</TableCell>
              )}
              {check.inactiveUsers && (
                <TableCell align="center">Total Inactive user</TableCell>
              )}
              {check.depPoints && (
                <TableCell
                  sx={{ borderRadius: '0px 20px 0px 0px' }}
                  align="center">
                  Total Department Points
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {data &&
              data?.data?.map((row, index) => (
                <>
                  <div className="row__spacing"></div>
                  <TableRow
                    className="tableUi___body"
                    key={row?.index}
                    // sx={{
                    //   // "&:last-child td, &:last-child th": {
                    //   //   border: "1px solid grey",
                    //   // },
                    //   borderRadius: "20px",
                    // }}
                    sx={{ borderRadius: '15px' }}>
                    {check.depName && (
                      <TableCell
                        sx={{
                          borderRadius: '15px 0px 0px 15px',
                          //     border: "1px solid grey",
                        }}
                        align="center">
                        {row?.name}
                      </TableCell>
                    )}
                    {check.hod && (
                      <TableCell align="center">
                        {row?.hod?.fname && row.hod?.lname
                          ? `${row?.hod?.fname} ${row?.hod?.lname}`
                          : row.hod?.email}
                      </TableCell>
                    )}
                    {check.totalUsers && (
                      <TableCell align="center">{row?.totalUsers}</TableCell>
                    )}
                    {check.activeUsers && (
                      <TableCell align="center">
                        {row?.totalActiveUsers}
                      </TableCell>
                    )}
                    {check.inactiveUsers && (
                      <TableCell align="center">
                        {row?.totalInActiveUsers}
                      </TableCell>
                    )}

                    {check.depPoints && (
                      <TableCell
                        sx={{
                          borderRadius: '0px 15px 15px 0px',
                          //     border: "1px solid grey",
                        }}
                        align="center">
                        {row?.totalDepartmentPoints}
                      </TableCell>
                    )}
                  </TableRow>
                  <div className="row__spacing"></div>
                </>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
